<template>
  <div>
    <el-form
      :model="form"
      label-width="150px"
    >
      <el-form-item :label="$t('name')">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('max_users')">
        <el-input-number
          v-model="form.usersLimit"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('max_studies')">
        <el-input-number
          v-model="form.studiesLimit"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('max_competitors')">
        <el-input-number
          v-model="form.competitorsLimit"
          :min="1"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <div class="text-right">
      <el-button
        plain
        @click="closeDialog"
        >{{ $t("cancel") }}</el-button
      >
      <el-button
        plain
        type="primary"
        @click="submitForm"
        >{{ $t("confirm") }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/repositoryFactory";
const CompanyGroupsRepository = RepositoryFactory.get("companyGroups");

export default {
  props: {
    companyGroupId: Number,
  },
  data() {
    return {
      form: {
        name: "",
        usersLimit: 1,
        competitorsLimit: 1,
        studiesLimit: 1,
      }
    };
  },
  methods: {
    submitForm() {
      this.closeDialog();
      this.$emit("submit", this.form);
      if (!this.companyGroupId) {
        this.resetForm();
      }
    },
    closeDialog() {
      this.$emit("close-dialog");
    },
    resetForm() {
      this.form.name = "";
      this.form.usersLimit = 1;
      this.form.competitorsLimit = 1;
      this.form.studiesLimit = 1;
    },
    loadCompanyGroup() {
      CompanyGroupsRepository.getCompanyGroup(this.companyGroupId)
        .then((data) => {
          this.form = data.data.attributes;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    if (this.companyGroupId) this.loadCompanyGroup();
  },
  watch: {
    companyGroupId() {
      if (this.companyGroupId) this.loadCompanyGroup();
    },
  },
};
</script>

<style scoped lang="scss">
.text-right {
  text-align: right;
}
</style>

<i18n>
{
  "en": {
    "name": "name",
    "max_users": "Max users",
    "max_studies": "Max studies",
    "max_competitors": "Max competitors",
    "cancel": "Cancel",
    "confirm": "Confirm"
  },
  "fr": {
    "name": "Nom",
    "max_users": "Max utilisateurs",
    "max_studies": "Max études",
    "max_competitors": "Max concurrents",
    "cancel": "Annuler",
    "confirm": "Confirmer"
  },
  "de": {
    "name": "Name",
    "max_users": "Maximale Benutzer",
    "max_studies": "Max studiert",
    "max_competitors": "Maximale Konkurrenten",
    "cancel": "Stornieren",
    "confirm": "Bestätigen"
  }
}
</i18n>
